import React from "react";
import { useCuerpo } from "../context/CuerpoContext";

const MENSAJE_DEFAULT =
  "Este Cuerpo de Bomberos se encuentra temporalmente desactivado por Digital Evolution BM. Para mayor información, comuníquese con la administración de su institución.";

export default function CuerpoDesactivado() {
  const { cuerpo } = useCuerpo();
  const nombre = cuerpo?.nombre || "Cuerpo de Bomberos";
  const mensaje = String(cuerpo?.mensajeDesactivado || cuerpo?.mensaje_desactivado || "").trim() || MENSAJE_DEFAULT;
  const logo = String(cuerpo?.logoURL || cuerpo?.logo_url || cuerpo?.logoUrl || cuerpo?.logo || "").trim();

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, background: "#f4f6f8" }}>
      <div style={{ maxWidth: 720, width: "100%", background: "white", borderRadius: 18, padding: 36, textAlign: "center", boxShadow: "0 14px 40px rgba(0,0,0,.12)" }}>
        {logo && <img src={logo} alt={nombre} style={{ maxWidth: 170, maxHeight: 170, objectFit: "contain", marginBottom: 18 }} />}
        <h1 style={{ margin: "0 0 12px" }}>{nombre}</h1>
        <h2 style={{ margin: "0 0 22px", color: "#b42318" }}>Plataforma temporalmente desactivada</h2>
        <p style={{ fontSize: 18, lineHeight: 1.55, color: "#344054", whiteSpace: "pre-wrap" }}>{mensaje}</p>
        <div style={{ marginTop: 28, fontWeight: 700, color: "#667085" }}>Digital Evolution BM</div>
      </div>
    </div>
  );
}
